import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import balanceText from 'balance-text'
import {
  OrdforklaringToggle,
  OrdforklaringTooltip,
} from './components/ordforklaring/ordforklaring-tooltip.js'
import { ShareLinks } from './components/footer/footer.ts'
import styles from './components/stilbar-artikkel.module.css'
import './components/grid.module.css'
import './components/logo/logo.module.css'
import './components/ordforklaring/ordforklaring-tooltip.module.css'
import './components/polopoly/overrides/article.module.css'
import './components/polopoly/overrides/section.module.css'
import './components/polopoly/overrides/email.module.css'
import './components/polopoly/overrides/fact.module.css'
import './components/sanity/overrides/chatlog.module.css'
import './components/sanity/overrides/lydlogg.module.css'
import './components/footer/footer.module.css'
import './components/pakker/bilde-og-tekstpakke.module.css'
import './components/pakker/tekstboks.module.css'
import { SALevendeStillbilde } from './lib/levende-stillbilde.ts'

// import hydrate from './components/hydrate'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

class AppElement extends HTMLElement {
  name = tag

  connectedCallback() {
    safeDefine('ordforklaring-tooltip', OrdforklaringTooltip)
    safeDefine('core-toggle', OrdforklaringToggle)
    safeDefine('share-links', ShareLinks)
    safeDefine('dhsa-levende-stillbilde', SALevendeStillbilde)

    // TODO: Remove polyfill once Safari supports text-wrap: balance
    // https://caniuse.com/css-text-wrap-balance
    if (!CSS.supports('text-wrap', 'balance')) {
      /*
       The following selector is a bit cryptic.

       1. We exclude elements that has a parent `.disable-balance-polyfill` class,
       using `.${styles.balanceText}:not(:is(.disable-balance-polyfill .${styles.balanceText}))`

       (The balanceText class must be repeated for performance)

       2. We exclude elements that contain manual `<br>` elements:

       Balance text fails if the element contains `<br>` elements it doesn't control.
       We could select all elements that does not contain `<br>` with this selector: `.balance-text:not(:has(br))`

       Unfortunately balance-text injects its own `<br data-owner="balance-text">` elements.
       We need to exclude these: `.balance-text:not(:has(br:not([data-owner])))`
      */
      balanceText(
        `.${styles.balanceText}:not(:is(.disable-balance-polyfill .${styles.balanceText})):not(:is(:has(br:not([data-owner]))))`,
        { watch: true },
      )
    }

    const backgroundColor = getComputedStyle(document.body).backgroundColor
    let themeMeta = document.querySelector("meta[name='theme-color']")
    if (!themeMeta) {
      themeMeta = document.createElement('meta')
      themeMeta.setAttribute('name', 'theme-color')
      document.querySelector('head').appendChild(themeMeta)
    }
    themeMeta.setAttribute('content', backgroundColor)
  }

  get features() {
    return JSON.parse(this.getAttribute('features') ?? '{}')
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
